












import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { SystemSettingInfo } from '@/appsync/graphql/systemSettingInfo';
import GeneralSettingProfile from '@/components/organisms/GeneralSettingProfile.vue';
import { AnnouncementSetting } from '@/types/type';

@Component({
  components: { GeneralSettingProfile },
})
export default class GeneralSettingBody extends Vue {
  @Prop()
  private loading!: boolean;
  @Prop()
  private isMultilanguageEnabled!: boolean;
  @Prop()
  private isJobSchedulerEnabled!: boolean;
  @Prop()
  private isPortalEnabled!: boolean;
  @Prop()
  private announcementSetting!: AnnouncementSetting;

  @Emit('save-general-setting')
  private saveGeneralSetting(
    generalSetting: SystemSettingInfo
  ): SystemSettingInfo {
    return generalSetting;
  }
}
